import { ExResizeHandle } from '@boomi/exosphere';
import type { TaskDataManagerData } from './TaskDataManager';
import TaskDetail from './taskDetail/TaskDetail';
import TaskList from './taskList/TaskList';

export const AppBody = ({
    inboxTasks,
    isLoadingInbox,
    getNextInboxTasksPage,
    isMoreToLoad,
    totalCount,
    selectedTask,
    isLoadingSelectedTask,
    loadSelectedTask,
    selectedTaskId,
    approveTask,
    rejectTask,
    currentTab,
    currentStatus,
    updateFilters,
}: TaskDataManagerData) => {
    return (
        <div className="pane-container">
            <div id="left-pane">
                <TaskList
                    inboxTasks={inboxTasks}
                    isLoadingInbox={isLoadingInbox}
                    isMoreToLoad={isMoreToLoad}
                    loadSelectedTask={loadSelectedTask}
                    getNextInboxTasksPage={getNextInboxTasksPage}
                    selectedTaskId={selectedTaskId}
                    totalCount={totalCount}
                    currentTab={currentTab}
                    currentStatus={currentStatus}
                    updateFilters={updateFilters}
                />
            </div>
            <ExResizeHandle maxWidth={Infinity} targetId="left-pane" />
            <div id="right-pane">
                <TaskDetail
                    selectedTask={selectedTask}
                    loadSelectedTask={loadSelectedTask}
                    isLoadingSelectedTask={isLoadingSelectedTask}
                    approveTask={approveTask}
                    rejectTask={rejectTask}
                />
            </div>
        </div>
    );
};
